export default theme => ({
  topbar: {
    position: "fixed",
    width: "100%",
    top: 0,
    left: "auto",
    right: 0,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  topbarShift: {
    marginRight: "271px",
    width: "calc(-282px + 100vw)"
  },
  topbarShiftLtr: {
    marginLeft: "279px",
    width: "calc(-279px + 100vw)",
    direction: "ltr"
  },
  drawerPaper: {
    zIndex: 1200,
    width: "282px",
    overflow: "hidden scroll"
  },
  sidebar: {
    width: "270px"
  },
  content: {
    marginTop: "64px",
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentShift: {
    marginRight: "270px"
  },
  contentShiftLtr: {
    marginLeft: "270px"
  }
});
